import { ITheme } from "survey-core";
import { baseThemeJson } from "../Quiz/baseTheme";

export default {
    ...baseThemeJson,
    cssVariables: {
        ...baseThemeJson.cssVariables,
        "--sjs-primary-backcolor": "#183690",
    },
} as ITheme;
